import HomeApi from '@api/home'
import {
  HOME_INIT_PRODUCT
} from '../mutationTypes'

const state = {
  productList: []
}

const getters = {}

const actions = {
  // 已购买产品
  async fetchProductInfo({ commit }) {
    const data = await HomeApi.fetchProductInfo()
    commit(HOME_INIT_PRODUCT, data)
  }
}

const mutations = {
  [HOME_INIT_PRODUCT] (state, data) {
    state.productList = Object.freeze(data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}